import React from 'react';
import { Link } from 'react-router-dom';
import { brand } from '../data/brand';
import { pages } from '../data/pages';
import { ContactMenu } from './ContactMenu';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex min-h-screen w-full flex-col bg-ink-900" data-id="element-24" data-mp="zwmjy8kr8y9g">
      <header className="sticky top-0 z-30 border-b border-white/[0.07] bg-ink-900/90 backdrop-blur" data-id="element-25" data-mp="uzcn47v1dkbl">
        <div className="mx-auto flex h-14 w-full max-w-content items-center justify-between gap-3 px-4 sm:px-8" data-id="element-26" data-mp="79s0nezoc4xk">
          <Link to={`/${pages[0].slug}`} className="flex items-center gap-2.5 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400" aria-label="LetLois onboarding — start" data-id="element-27" data-mp="2b717hs8xpa6">
            <img src={brand.wordmark} alt="LetLois" className="h-6 w-auto" width={120} height={24} data-id="element-28" data-mp="3knn10gz99jr5" />
            <span className="border-l border-white/15 pl-2.5 text-[13px] font-medium text-white/45 sm:text-sm" data-id="element-29" data-mp="3fmpl6b1px1st">
              Onboarding
            </span>
          </Link>
          <ContactMenu data-id="element-30" data-mp="1ms7dda7dg294" />
        </div>
      </header>

      <main className="flex-1" data-id="element-31" data-mp="1rkqtoexg1bhm">{children}</main>
    </div>;
}